import request from '@utils/fetch'

export function editNaturalSpellingApi(data) {
  return request({
    url: '/themeManage/editNaturalSpelling ',
    method: 'post',
    data
  })
}

export function deleteNaturalSpellingApi(data) {
  return request({
    url: '/themeManage/editTreeBasicMeans',
    method: 'delete',
    data
  })
}
export function editWordApi(data) {
  return request({
    url: '/themeManage/editWord',
    method: 'post',
    data
  })
}

// 编辑句型
export function editSentencePattern(data) {
  return request({
    url: '/themeManage/editSentencePattern',
    method: 'post',
    data
  })
}
// 编辑高频词
export function editHighFrequencyApi(data) {
  return request({
    url: '/themeManage/editHighFrequency ',
    method: 'post',
    data
  })
}
// 删除句型组
export function deleteWordGroupApi(data) {
  return request({
    url: '/themeManage/editGroupBasicMeans',
    method: 'delete',
    data
  })
}

// 统一的删除接口
export function delBasicMeans(data) {
  return request({
    url: '/themeManage/delBasicMeans',
    method: 'delete',
    data
  })
}
// 查询句型组
export function serachDetail(data) {
  return request({
    url: '/themeManage/editGroupBasicMeans',
    method: 'post',
    data
  })
}

// 修改句型组
export function editSentenceGroupPattern(data) {
  return request({
    url: '/themeManage/editSentencePatternGroup',
    method: 'post',
    data
  })
}

